import { extend } from "dayjs";
import duration from "dayjs/plugin/duration";

/**
 * Extend dayjs with plugins globally
 * - this file should be imported before any other dayjs usage
 * - issue link: https://github.com/iamkun/dayjs/issues/1577
 */
extend(duration);
